import moment from 'moment';
import downloadjs from 'downloadjs';
import { format, subDays } from 'date-fns';

import { luftGet, luftPost, luftDelete, luftDownload } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

import {
  tmsStatus,
  wmsStatus,
  isFinishedWMSStatus,
  isFinishedTMSStatus,
} from '../pages/Tracking/utils/delivery-status';
import { USER_TYPES } from '../pages/Admin/shared/static-options';

import DynamicAPI from '../shared/axios';
import { showToastError, showToastSuccess } from '../components/toasty';

// region ACTIONS
// actions

const CHANGE_FILTERS = 'luft/tracking/CHANGE_FILTERS';
const FILTERS_CLEAR = 'luft/tracking/FILTERS_CLEAR';

const GET_NF_LIST = 'luft/tracking/GET_NF_LIST';
const GET_NF_LIST_SUCCESS = 'luft/tracking/GET_NF_LIST_SUCCESS';
const GET_NF_LIST_FAILURE = 'luft/tracking/GET_NF_LIST_FAILURE';

const VIEW_NF_DETAILS = 'voud/tracking/VIEW_NF_DETAILS';

const EXPORT_DETAILED_EXCEL = 'luft/tracking/EXPORT_DETAILED_EXCEL';
const EXPORT_DETAILED_EXCEL_SUCCESS =
  'luft/tracking/EXPORT_DETAILED_EXCEL_SUCCESS';
const EXPORT_DETAILED_EXCEL_FAILURE =
  'luft/tracking/EXPORT_DETAILED_EXCEL_FAILURE';

const EXPORT_EXCEL = 'luft/tracking/EXPORT_EXCEL';
const EXPORT_EXCEL_SUCCESS = 'luft/tracking/EXPORT_EXCEL_SUCCESS';
const EXPORT_EXCEL_FAILURE = 'luft/tracking/EXPORT_EXCEL_FAILURE';

const ADD_NF_EMAIL_TRACKING = 'luft/tracking/ADD_NF_EMAIL_TRACKING';
const ADD_NF_EMAIL_TRACKING_SUCCESS =
  'luft/tracking/ADD_NF_EMAIL_TRACKING_SUCCESS';
const ADD_NF_EMAIL_TRACKING_FAILURE =
  'luft/tracking/ADD_NF_EMAIL_TRACKING_FAILURE';

const REMOVE_NF_EMAIL_TRACKING = 'luft/tracking/REMOVE_NF_EMAIL_TRACKING';
const REMOVE_NF_EMAIL_TRACKING_SUCCESS =
  'luft/tracking/REMOVE_NF_EMAIL_TRACKING_SUCCESS';
const REMOVE_NF_EMAIL_TRACKING_FAILURE =
  'luft/tracking/REMOVE_NF_EMAIL_TRACKING_FAILURE';

const GET_ACTIVE_NF_FORECAST_HISTORY =
  'luft/tracking/GET_ACTIVE_NF_FORECAST_HISTORY';
const GET_ACTIVE_NF_FORECAST_HISTORY_SUCCESS =
  'luft/tracking/GET_ACTIVE_NF_FORECAST_HISTORY_SUCCESS';
const GET_ACTIVE_NF_FORECAST_HISTORY_FAILURE =
  'luft/tracking/GET_ACTIVE_NF_FORECAST_HISTORY_FAILURE';

const GET_ACTIVE_NF_LIST_STATUS = 'luft/tracking/GET_ACTIVE_NF_LIST_STATUS';
const GET_ACTIVE_NF_LIST_STATUS_SUCCESS =
  'luft/tracking/GET_ACTIVE_NF_LIST_STATUS_SUCCESS';
const GET_ACTIVE_NF_LIST_STATUS_FAILURE =
  'luft/tracking/GET_ACTIVE_NF_LIST_STATUS_FAILURE';

const GET_ACTIVE_NF_OCCURRENCES = 'luft/tracking/GET_ACTIVE_NF_OCCURRENCES';
const GET_ACTIVE_NF_OCCURRENCES_SUCCESS =
  'luft/tracking/GET_ACTIVE_NF_OCCURRENCES_SUCCESS';
const GET_ACTIVE_NF_OCCURRENCES_FAILURE =
  'luft/tracking/GET_ACTIVE_NF_OCCURRENCES_FAILURE';

const CHANGE_SEARCH_FIELD_IS_IN_USE =
  'luft/tracking/CHANGE_SEARCH_FIELD_IS_IN_USE';

// endregion

// region INITIAL STATE + REDUCER
// reducer

const filtersInitialState = {
  query: '',

  initialPeriod: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
  finalPeriod: format(new Date(), 'yyyy-MM-dd'),

  listCompany: [],
  listRegion: [],
  listStatusPerformanceTms: [],
  listStatusPerformanceWms: [],
  listAllowance: [],
  listContractedService: [],
  listStatus: [],
  listPerformance: [],
  listCustomerTMS: [],
  listSubsidiaries: [],

  listSubsidiariesLuft: [],
  carrierCnpj: [],
  byDate: 2,

  scheduled: [],
  nfType: [],
  following: [],

  currentPage: 1,
  pageLimit: 10,
};

const initialState = {
  filters: {
    ...filtersInitialState,
  },
  nfList: {
    isFetching: false,
    error: '',
    requested: '',
    data: {
      list: [],
      totalItems: 0,
    },
  },
  customers: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  currentNFDetailsId: null,
  exportDetailedExcel: {
    isFetching: false,
    error: '',
    requested: '',
  },
  exportExcel: {
    isFetching: false,
    error: '',
    requested: '',
  },
  addNFEmailTracking: {
    isFetching: false,
    error: '',
    requested: '',
  },
  removeNFEmailTracking: {
    isFetching: false,
    error: '',
    requested: '',
  },
  activeNfForecastHistory: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  activeNfListStatus: {
    isFetching: false,
    error: '',
    requested: '',
    data: {
      wmsList: [],
      tmsList: [],
    },
  },
  activeNfOccurrences: {
    isFetching: false,
    error: '',
    data: [],
  },
  searchFieldIsInUse: false,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SEARCH_FIELD_IS_IN_USE:
      return {
        ...state,
        searchFieldIsInUse: action.searchFieldIsInUse,
      };

    // filters
    case CHANGE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };

    case FILTERS_CLEAR:
      return {
        ...state,
        filters: {
          ...filtersInitialState,
        },
      };

    // NF list

    case GET_NF_LIST:
      return {
        ...state,
        nfList: {
          ...state.nfList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_NF_LIST_SUCCESS: {
      const { list } = action;
      return {
        ...state,
        nfList: {
          ...state.nfList,
          isFetching: false,
          error: '',
          data: {
            list: list.map(el => ({
              ...el,
              wms: {
                ...el.wms,
                hasStarted: true,
                hasFinished: isFinishedWMSStatus(el.wms.status),
              },
              tms: {
                ...el.tms,
                hasStarted: el.tms.status !== tmsStatus.WAITING_NF_ENTRY,
                hasFinished: isFinishedTMSStatus(el.tms.status),
              },
              latestStatus: {
                lastStatus:
                  isFinishedWMSStatus(el.wms.status) ||
                    el.wms.status === wmsStatus.SERVICE_NOT_CONTRACTED
                    ? el.tms.progress.lastStatus
                    : el.wms.progress.lastStatus,
                lastStatusDate:
                  isFinishedWMSStatus(el.wms.status) ||
                    el.wms.status === wmsStatus.SERVICE_NOT_CONTRACTED
                    ? el.tms.progress.lastStatusDate
                    : el.wms.progress.lastStatusDate,
              },
            })),
            totalItems: list && list.length > 0 ? list[0].totalLines : 0,
          },
        },
      };
    }

    case GET_NF_LIST_FAILURE:
      return {
        ...state,
        nfList: {
          ...state.nfList,
          isFetching: false,
          error: action.error,
        },
      };

    case VIEW_NF_DETAILS:
      return {
        ...state,
        currentNFDetailsId: action.id,
      };

    case EXPORT_DETAILED_EXCEL:
      return {
        ...state,
        exportDetailedExcel: {
          ...state.exportDetailedExcel,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case EXPORT_DETAILED_EXCEL_SUCCESS:
      return {
        ...state,
        exportDetailedExcel: {
          ...state.exportDetailedExcel,
          isFetching: false,
          error: '',
        },
      };

    case EXPORT_DETAILED_EXCEL_FAILURE:
      return {
        ...state,
        exportDetailedExcel: {
          ...state.exportDetailedExcel,
          isFetching: false,
          error: action.error,
        },
      };

    case EXPORT_EXCEL:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case EXPORT_EXCEL_SUCCESS:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          isFetching: false,
          error: '',
        },
      };

    case EXPORT_EXCEL_FAILURE:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_NF_EMAIL_TRACKING:
      return {
        ...state,
        addNFEmailTracking: {
          ...state.addNFEmailTracking,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case ADD_NF_EMAIL_TRACKING_SUCCESS:
      return {
        ...state,
        addNFEmailTracking: {
          ...state.addNFEmailTracking,
          isFetching: false,
          error: '',
        },
        nfList: {
          ...state.nfList,
          data: {
            ...state.nfList.data,
            list: state.nfList.data.list.map(nfItem =>
              nfItem.id === action.id ? { ...nfItem, following: true } : nfItem,
            ),
          },
        },
      };

    case ADD_NF_EMAIL_TRACKING_FAILURE:
      return {
        ...state,
        addNFEmailTracking: {
          ...state.addNFEmailTracking,
          isFetching: false,
          error: action.error,
        },
      };

    case REMOVE_NF_EMAIL_TRACKING:
      return {
        ...state,
        removeNFEmailTracking: {
          ...state.removeNFEmailTracking,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case REMOVE_NF_EMAIL_TRACKING_SUCCESS:
      return {
        ...state,
        removeNFEmailTracking: {
          ...state.removeNFEmailTracking,
          isFetching: false,
          error: '',
        },
        nfList: {
          ...state.nfList,
          data: {
            ...state.nfList.data,
            list: state.nfList.data.list.map(nfItem =>
              nfItem.id === action.id
                ? { ...nfItem, following: false }
                : nfItem,
            ),
          },
        },
      };

    case REMOVE_NF_EMAIL_TRACKING_FAILURE:
      return {
        ...state,
        removeNFEmailTracking: {
          ...state.removeNFEmailTracking,
          isFetching: false,
          error: action.error,
        },
      };

    // NF ForecastHistory
    case GET_ACTIVE_NF_FORECAST_HISTORY:
      return {
        ...state,
        activeNfForecastHistory: {
          ...state.activeNfForecastHistory,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_ACTIVE_NF_FORECAST_HISTORY_SUCCESS: {
      return {
        ...state,
        activeNfForecastHistory: {
          ...state.activeNfForecastHistory,
          isFetching: false,
          data: action.data,
        },
      };
    }

    case GET_ACTIVE_NF_FORECAST_HISTORY_FAILURE: {
      return {
        ...state,
        activeNfForecastHistory: {
          ...state.activeNfForecastHistory,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // NF List Status
    case GET_ACTIVE_NF_LIST_STATUS:
      return {
        ...state,
        activeNfListStatus: {
          ...state.activeNfListStatus,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_ACTIVE_NF_LIST_STATUS_SUCCESS:
      return {
        ...state,
        activeNfListStatus: {
          ...state.activeNfListStatus,
          isFetching: false,
          data: action.data,
        },
      };

    case GET_ACTIVE_NF_LIST_STATUS_FAILURE:
      return {
        ...state,
        activeNfListStatus: {
          ...state.activeNfListStatus,
          isFetching: false,
          error: action.error,
        },
      };

    // get active nf occurrences
    case GET_ACTIVE_NF_OCCURRENCES: {
      return {
        ...state,
        activeNfOccurrences: {
          ...state.activeNfOccurrences,
          isFetching: true,
        },
      };
    }

    case GET_ACTIVE_NF_OCCURRENCES_SUCCESS: {
      return {
        ...state,
        activeNfOccurrences: {
          ...state.activeNfOccurrences,
          isFetching: false,
          data: action.data,
        },
      };
    }

    case GET_ACTIVE_NF_OCCURRENCES_FAILURE: {
      return {
        ...state,
        activeNfOccurrences: {
          ...state.activeNfOccurrences,
          isFetching: false,
          error: action.error,
        },
      };
    }

    // Default
    default:
      return state;
  }
}

export default reducer;

export function changeSearchFieldIsInUse(searchFieldIsInUse = false) {
  return {
    type: CHANGE_SEARCH_FIELD_IS_IN_USE,
    searchFieldIsInUse,
  };
}

// endregion

// region ACTION CREATORS
// actions creators

// filters

export function changeFilters(filters = {}) {
  return {
    type: CHANGE_FILTERS,
    filters,
  };
}

export function filtersClear() {
  return {
    type: FILTERS_CLEAR,
  };
}

// NF list

function _getNFList() {
  return {
    type: GET_NF_LIST,
  };
}

function _getNFListSuccess(list) {
  return {
    type: GET_NF_LIST_SUCCESS,
    list,
  };
}

function _getNFListFailure(error) {
  return {
    type: GET_NF_LIST_FAILURE,
    error,
  };
}

// NF Details

export function viewNFDetails(id) {
  return {
    type: VIEW_NF_DETAILS,
    id,
  };
}

// NF Export Detailed Excel

function _exportDetailedExcel() {
  return { type: EXPORT_DETAILED_EXCEL };
}

function _exportDetailedExcelSuccess() {
  return { type: EXPORT_DETAILED_EXCEL_SUCCESS };
}

function _exportDetailedExcelFailure(error) {
  return {
    type: EXPORT_DETAILED_EXCEL_FAILURE,
    error,
  };
}

// NF Export Excel

function _exportExcel() {
  return { type: EXPORT_EXCEL };
}

function _exportExcelSuccess() {
  return { type: EXPORT_EXCEL_SUCCESS };
}

function _exportExcelFailure(error) {
  return {
    type: EXPORT_EXCEL_FAILURE,
    error,
  };
}

// NF Email Tracking

function _addNFEmailTracking() {
  return { type: ADD_NF_EMAIL_TRACKING };
}

function _addNFEmailTrackingSuccess(id) {
  return {
    type: ADD_NF_EMAIL_TRACKING_SUCCESS,
    id,
  };
}

function _addNFEmailTrackingFailure(error) {
  return {
    type: ADD_NF_EMAIL_TRACKING_FAILURE,
    error,
  };
}

function _removeNFEmailTracking() {
  return { type: REMOVE_NF_EMAIL_TRACKING };
}

function _removeNFEmailTrackingSuccess(id) {
  return {
    type: REMOVE_NF_EMAIL_TRACKING_SUCCESS,
    id,
  };
}

function _removeNFEmailTrackingFailure(error) {
  return {
    type: REMOVE_NF_EMAIL_TRACKING_FAILURE,
    error,
  };
}

// Active NF Forecast History

function _getActiveNfForecastHistory() {
  return {
    type: GET_ACTIVE_NF_FORECAST_HISTORY,
  };
}

function _getActiveNfForecastHistorySuccess(data) {
  return {
    type: GET_ACTIVE_NF_FORECAST_HISTORY_SUCCESS,
    data,
  };
}

function _getActiveNfForecastHistoryFailure(error) {
  return {
    type: GET_ACTIVE_NF_FORECAST_HISTORY_FAILURE,
    error,
  };
}

// Active NF List Status
function _getActiveNfListStatus() {
  return {
    type: GET_ACTIVE_NF_LIST_STATUS,
  };
}

function _getActiveNfListStatusSuccess(data) {
  return {
    type: GET_ACTIVE_NF_LIST_STATUS_SUCCESS,
    data,
  };
}

function _getActiveNfListStatusFailure(error) {
  return {
    type: GET_ACTIVE_NF_LIST_STATUS_FAILURE,
    error,
  };
}

function _getActiveNfOccurrences() {
  return {
    type: GET_ACTIVE_NF_OCCURRENCES,
  };
}

function _getActiveNfOccurrencesSuccess(data) {
  return {
    type: GET_ACTIVE_NF_OCCURRENCES_SUCCESS,
    data,
  };
}

function _getActiveNfOccurrencesFailure(error) {
  return {
    type: GET_ACTIVE_NF_OCCURRENCES_FAILURE,
    error,
  };
}

// endregion

// region THUNKS
// thunk action creators

export function _buildFiltersParams(filters, hasPagination) {
  // extract filter params from state
  const {
    query,
    initialPeriod,
    finalPeriod,
    listCompany,
    listRegion,
    listStatusPerformanceTms,
    listStatusPerformanceWms,
    listAllowance,
    listContractedService,
    scheduled,
    following,
    listStatus,
    listPerformance,
    listCustomerTMS,
    nfType,
    byDate,
    listSubsidiaries,
    listSubsidiariesLuft,
    currentPage,
    pageLimit,
    carrierCnpj,
  } = filters;

  return {
    ...(query !== ''
      ? { query, page: currentPage, amount: pageLimit }
      : {
        ...(initialPeriod && { initialPeriod, finalPeriod }),
        listCompany,
        listRegion,
        listStatusPerformanceTms,
        listStatusPerformanceWms,
        listAllowance,
        listContractedService,
        scheduled,
        following,
        listStatus,
        listPerformance,
        listCustomerTMS,
        nfType,
        byDate,
        listSubsidiaries,
        listSubsidiariesLuft,
        carrierCnpj,
        ...(hasPagination ? { page: currentPage, amount: pageLimit } : {}),
      }),
  };
}

function mockCarbonResponse(realResponse) {
  const MOCK_RESPONSE = [];

  realResponse.data.map((item, index) => {
    if (index === 0) {
      MOCK_RESPONSE.push({
        ...item,
        carbonEmission: 0.0003789426,
        predictedCarbonEmission: 0.0003789477,
        carbonCredit: 800,
      });
    }

    if (index === 1) {
      MOCK_RESPONSE.push({
        ...item,
        carbonEmission: null,
        predictedCarbonEmission: 0.0003789477,
        carbonCredit: null,
      });
    }

    if (index === 2) {
      MOCK_RESPONSE.push({
        ...item,
        carbonEmission: null,
        predictedCarbonEmission: null,
        carbonCredit: null,
      });
    }

    if (index >= 3) {
      MOCK_RESPONSE.push({
        ...item,
      });
    }
  });

  return MOCK_RESPONSE;
}

export function getNFList() {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_getNFList());
      try {
        const params = _buildFiltersParams(getState().tracking.filters, true);
        const { userType, activeCompanyId } = getState().auth;
        const http = new DynamicAPI('v5');
        const response = await http.get(
          '/IntegratedTracking/GetIntegratedTrackingList',
          {
            ...params,
            ...(userType === USER_TYPES.CUSTOMER_SERVICE_USER &&
            {
              companyId: activeCompanyId
            }
            )
          },
        );

        const useMock = false;
        const MOCK_RESPONSE = mockCarbonResponse(response);
        
        if (useMock) {
          dispatch(_getNFListSuccess(MOCK_RESPONSE));
        } else {
          dispatch(_getNFListSuccess(response.data));
        }
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getNFListFailure('Ops! Parece que tivemos um erro interno. Tente novamente mais tarde.'),
        );
      }
    })();
  };
}

export function exportDetailedExcel() {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_exportDetailedExcel());

      try {
        const { activeCompanyId } = getState().auth;
        const params = _buildFiltersParams(getState().tracking.filters, false);
        const mimeType = 'application/ms-excel';
        const response = await luftDownload(
          '/IntegratedTracking/ExportTrackingExcelWithOccurrencesBase64String',
          {
            ...params,
            companyId: activeCompanyId
          },
          'application/json' || null,
        );

        const data = `data:${mimeType};base64,${JSON.parse(response).data}`;
        const filename = 'tracking.xlsx';

        showToastSuccess('Exportando lista detalhada...');
        downloadjs(data, filename, mimeType);
        dispatch(_exportDetailedExcelSuccess());
      } catch (error) {
        console.log(error);
        showToastError('Erro ao exportar lista detalhada');
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _exportDetailedExcelFailure(error.message),
        );
      }
    })();
  };
}

export function exportExcel() {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_exportExcel());

      try {
        const { activeCompanyId } = getState().auth;
        const params = _buildFiltersParams(getState().tracking.filters, false);
        const mimeType = 'application/ms-excel';
        const response = await luftDownload(
          '/IntegratedTracking/ExportTrackingExcelBase64String',
          {
            ...params,
            companyId: activeCompanyId,
          },
          'application/json' || null,
        );

        const data = `data:${mimeType};base64,${JSON.parse(response).data}`;
        const filename = 'tracking.xlsx';

        showToastSuccess('Exportando lista...');
        downloadjs(data, filename, mimeType);
        dispatch(_exportExcelSuccess());
      } catch (error) {
        console.log(error);
        showToastError('Erro ao exportar lista');
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _exportExcelFailure(error.message),
        );
      }
    })();
  };
}

export function addNFEmailTracking(id, nf, nfGroup, cnpjEmit, cnpjDest) {
  return function (dispatch) {
    return (async () => {
      dispatch(_addNFEmailTracking());
      try {
        const params = {
          nota_Fiscal: nf,
          serie_NF: nfGroup,
          cnpJ_Emissor_NF: cnpjEmit,
          cnpJ_Destinatario: cnpjDest,
        };

        await luftPost('/TrackingInvoiceStatus', params);
        dispatch(_addNFEmailTrackingSuccess(id));

        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _addNFEmailTrackingFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function removeNFEmailTracking(id, nf, nfGroup, cnpjEmit, cnpjDest) {
  return function (dispatch) {
    return (async () => {
      dispatch(_removeNFEmailTracking());
      try {
        const params = {
          nota_Fiscal: nf,
          serie_NF: nfGroup,
          cnpJ_Emissor_NF: cnpjEmit,
          cnpJ_Destinatario: cnpjDest,
        };

        await luftDelete('/TrackingInvoiceStatus', params);
        dispatch(_removeNFEmailTrackingSuccess(id));

        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _removeNFEmailTrackingFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function getActiveNfForecastHistory(nfParams) {
  return function (dispatch) {
    (async () => {
      dispatch(_getActiveNfForecastHistory());
      try {
        const response = await luftGet(
          '/IntegratedTracking/GetTrackingDeliveryForecastHistory',
          nfParams,
          true,
        );
        dispatch(_getActiveNfForecastHistorySuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getActiveNfForecastHistoryFailure(error.message),
        );
      }
    })();
  };
}

export function getActiveNfListStatus(nfData) {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_getActiveNfListStatus());

      const { userType, activeCompanyId } = getState().auth;

      const params = {
        nf: nfData.nf,
        nfGroup: nfData.nfGroup,
        cnpjDest: nfData.cnpjDest,
        cnpjEmit: nfData.cnpjEmit,
        dateNfCreated: nfData.orderDate, // order date
        division: 1, // AGRO
        order: nfData.order,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      try {
        const http = new DynamicAPI('v3');
        const response = await http.get(
          '/IntegratedTracking/GetIntegratedTrackingListSteps',
          params,
        );
        dispatch(_getActiveNfListStatusSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getActiveNfListStatusFailure(error.message),
        );
      }
    })();
  };
}

export function getActiveNfOccurrences(tmsId, nf) {
  return async function (dispatch, getState) {
    dispatch(_getActiveNfOccurrences());

    try {
      const { userType, activeCompanyId } = getState().auth;

      const params = {
        tmsId,
        nf,
        companyId:
          userType === USER_TYPES.CUSTOMER_SERVICE_USER
            ? activeCompanyId
            : null,
      };

      const response = await luftGet(
        '/IntegratedTracking/GetTrackingDeliveryOccurrences',
        params,
        true,
      );
      dispatch(_getActiveNfOccurrencesSuccess(response.data));
    } catch (error) {
      dispatch(_getActiveNfOccurrencesFailure(error));
    }
  };
}

// endregion
